import React, { useEffect } from 'react';
import { Merch } from './Merch';

export const ShoppingLanding = ({ addToCart, siteConfig }: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="w-full pt-16 min-h-screen bg-mabelita-surface text-mabelita-dark flex flex-col font-sans">
            {/* Hero Shopping Oficial */}
            <div className="relative h-[40vh] md:h-[50vh] bg-mabelita-dark overflow-hidden flex items-center justify-center">
                <div className="absolute inset-0 bg-gradient-to-b from-mabelita-dark/90 via-mabelita-dark/50 to-mabelita-dark/90 z-10"></div>
                <img
                    src="https://images.unsplash.com/photo-1501281668745-f7f5792203b5?auto=format&fit=crop&w=1920&q=80"
                    alt="Shopping con Mabelita"
                    className="absolute inset-0 w-full h-full object-cover opacity-60 scale-105 animate-[pulse_20s_ease-in-out_infinite_alternate] grayscale"
                />
                <div className="relative z-20 text-center px-4 w-full max-w-5xl mx-auto mt-12">
                    <span className="text-mabelita-light font-bold tracking-[0.2em] uppercase text-xs md:text-sm mb-6 inline-block bg-mabelita-light/10 p-2 rounded backdrop-blur-sm border border-mabelita-light/20 animate-in fade-in">
                        Merchandising Oficial
                    </span>
                    <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-mabelita-light mb-6 tracking-tight drop-shadow-2xl uppercase animate-in slide-in-from-bottom-8 duration-700">
                        Shopping con Mabelita
                    </h1>
                    <p className="text-xl md:text-2xl text-mabelita-light/80 font-light tracking-wide max-w-3xl mx-auto animate-in fade-in duration-1000 delay-300 leading-relaxed">
                        Lleva contigo el ritmo y la pasión de La Diva de los Andes. Recuerdos, accesorios y moda oficial para sus mayores fans.
                    </p>
                </div>
            </div>

            {/* Grid de Productos Filtrada */}
            <div className="-mt-12 md:-mt-16 z-30 relative px-4 md:px-0 mb-20">
                <Merch
                    addToCart={addToCart}
                    siteConfig={siteConfig}
                    hideHero={true}
                />
            </div>
        </div>
    );
};
